import Portal from '@mui/material/Portal'
import {
  faCheckCircle,
  faCircleExclamation,
  faInfoCircle,
  faTriangleExclamation
} from '@fortawesome/pro-duotone-svg-icons'

import { SnackbarRoot } from './styles'
import { snackbarClasses } from './classes'
import FaIcon from 'src/components/shared/faIcon/FaIcon'

export function Snackbar() {
  return (
    <Portal>
      <SnackbarRoot
        expand
        gap={12}
        closeButton
        offset={16}
        visibleToasts={4}
        position='top-right'
        className={snackbarClasses.root}
        toastOptions={{
          unstyled: true,
          classNames: {
            toast: snackbarClasses.toast,
            icon: snackbarClasses.icon,
            // content
            content: snackbarClasses.content,
            title: snackbarClasses.title,
            description: snackbarClasses.description,
            // button
            actionButton: snackbarClasses.actionButton,
            cancelButton: snackbarClasses.cancelButton,
            closeButton: snackbarClasses.closeButton,
            // state
            default: snackbarClasses.default,
            info: snackbarClasses.info,
            error: snackbarClasses.error,
            success: snackbarClasses.success,
            warning: snackbarClasses.warning
          }
        }}
        icons={{
          loading: <span className={snackbarClasses.loadingIcon} />,
          info: (
            <FaIcon className={snackbarClasses.iconSvg} icon={faInfoCircle} />
          ),
          success: (
            <FaIcon className={snackbarClasses.iconSvg} icon={faCheckCircle} />
          ),
          warning: (
            <FaIcon
              className={snackbarClasses.iconSvg}
              icon={faTriangleExclamation}
            />
          ),
          error: (
            <FaIcon
              className={snackbarClasses.iconSvg}
              icon={faCircleExclamation}
            />
          )
        }}
      />
    </Portal>
  )
}
